import util from '../../libs/util'
import { permissionRouterMap } from '../../router'
import commonGrid from '../../components/grid/common-grid.vue'
import alonePage from '../../components/iframe/iframe.vue'
import componentsMap from '../../components/components-register'
import {STORE_APP_MUTATION_TYPES, STORE_PERMISSION_ACTIONS_TYPES, STORE_PERMISSION_MUTATION_TYPES} from '../../libs/constants'

function setPermissionRouter(node) { // 根据菜单节点生成路由
  // 生成路由
  if (node.code && componentsMap[node.code]) { // 如果存在自定义组件和菜单code匹配, 则使用自定义组件
    permissionRouterMap[0].children.push({
      name: node.routerName || node.id,
      path: node.routerName || node.id,
      title: node.name,
      meta: {
        permissionId: node.routerName || node.id,
        url: node.url,
        gridId: node.gridId,
        menu: node
      },
      component: {
        name: node.routerName || node.id,
        extends: componentsMap[node.code]
      }
    })
  } else {
    if (node.url.indexOf('abstractGrid') > 0) { // 如果菜单url以"abstractGrid"结尾, 则使用grid组件
      permissionRouterMap[0].children.push({
        name: node.routerName || node.id,
        path: node.routerName || node.id,
        title: node.name,
        meta: {
          permissionId: node.routerName || node.id,
          url: node.url,
          gridId: node.gridId,
          menu: node
        },
        component: {
          name: node.routerName || node.id,
          extends: commonGrid
        }
      })
    } else { // 使用单页面组件(frame方式)
      permissionRouterMap[1].children.push({
        name: node.routerName || node.id,
        path: node.routerName || node.id,
        title: node.name,
        meta: {
          permissionId: node.routerName || node.id,
          url: node.url.startsWith('http') ? node.url : (util.baseUrl + node.url)
        },
        component: alonePage
      })
    }
  }
  // 如果包含子菜单, 递归遍历子菜单
  if (node.children && node.children.length > 0) {
    for (let i = 0; i < node.children.length; i++) {
      // 不在左侧菜单显示的node,把parent设置到node中,方便后续使用
      if (node.children[i].showInLeftMenu === '0') {
        node.children[i].parent = node
      }
      setPermissionRouter(node.children[i])
    }
  }
}

function generateGridRouter(gridConfigList) {
  if (gridConfigList) {
    for (let i = 0; i < gridConfigList.length; i++) {
      try {
        let routerType = gridConfigList[i]['routerType']
        let routerConfig = JSON.parse(gridConfigList[i]['routerConfig'])
        if (routerType === 'gridRouter') {
          let gridId = routerConfig['gridId']
          let url = routerConfig['url']
          const code = routerConfig['code']
          let toComponent = commonGrid
          if (code && componentsMap[code]) { // 如果存在自定义组件和自定义路由code匹配, 则使用自定义组件
            toComponent = componentsMap[code]
          }
          permissionRouterMap[0].children.push({
            name: gridId,
            path: gridId,
            title: gridId,
            meta: {
              url: url
            },
            component: {
              name: gridId,
              extends: toComponent
            }
          })
        } else if (routerType === 'mainRouter') {
          const name = routerConfig['name']
          const query = routerConfig['query']
          const meta = routerConfig['meta']
          if (name && componentsMap[name]) { // 如果存在自定义组件和自定义路由name匹配, 则使用自定义组件
            permissionRouterMap[0].children.push({
              name: name,
              path: name,
              title: name,
              query: query,
              meta: meta,
              component: {
                name: name,
                extends: componentsMap[name]
              }
            })
          }
        }
      } catch (e) {
        console.error(e)
      }
    }
  }
}

function clearTreeNode(node) {
  if (node.children && node.children.length > 0) {
    for (let i = node.children.length - 1; i >= 0; i--) {
      if (node.children[i].showInLeftMenu === '1') {
        clearTreeNode(node.children[i])
      } else {
        node.children.splice(i, 1)
      }
    }
  }
}

const permission = {
  state: {
    addRouters: [],
    permissionTree: [],
    menuTree: [],
    routersInitialized: false // 路由表是否被初始化
  },
  mutations: {
    [STORE_PERMISSION_MUTATION_TYPES.RESET_PERMISSION_STATE] (state) { // reset permission state
      state.addRouters = []
      state.permissionTree = []
      state.menuTree = []
      state.routersInitialized = false
    },
    SET_PERMISSION_TREE: (state, tree) => {
      state.permissionTree = tree
    },
    GET_PERMISSION_TREE: (state, tree) => {
      return state.permissionTree
    },
    SET_MENU_TREE: (state, tree) => {
      state.menuTree = tree
    },
    GET_MENU_TREE: (state, tree) => {
      return state.menuTree
    },
    [STORE_PERMISSION_MUTATION_TYPES.ROUTERS_INITIALIZED]: (state, payload) => {
      state.routersInitialized = payload
    }
  },
  actions: {
    GetPermission({ commit }) { // 获取权限树,包含不在左侧菜单显示的节点
      return new Promise((resolve, reject) => {
        let data = commit('GET_PERMISSION_TREE')
        if (data) {
          resolve(data)
        } else {
          util.ajax.post('/core/manager/left/tree').then((res) => {
            if (res.data) {
              commit('SET_PERMISSION_TREE', res.data.data)
            }
            resolve(res.data.data)
          }).catch(error => {
            reject(error)
          })
        }
      })
    },
    GetMenuTree({ commit }) { // 获取左侧菜单树,不包含不在左侧菜单显示的节点
      return new Promise((resolve, reject) => {
        let data = commit('GET_MENU_TREE')
        if (data) {
          resolve(data)
        } else {
          util.ajax.post('/core/manager/left/tree').then((res) => {
            if (res.data) {
              for (let i = res.data.data.length - 1; i >= 0; i--) {
                if (res.data.data[i].showInLeftMenu === '1') {
                  clearTreeNode(res.data.data[i])
                } else {
                  res.data.data.splice(i, 1)
                }
              }
              commit('SET_MENU_TREE', res.data.data)
            }
            resolve(res.data.data)
          }).catch(error => {
            reject(error)
          })
        }
      })
    },
    [STORE_PERMISSION_ACTIONS_TYPES.INIT_ROUTERS]({dispatch, commit}) { // 初始化路由表
      let getMenuTree = dispatch('GetPermission').then((data) => {
        if (data) {
          for (let i = 0; i < data.length; i++) {
            if (data[i].routerName === util.defaultMenuRouterName) {
              commit(STORE_APP_MUTATION_TYPES.SET_DEFAULT_MENU, data[i])
            }
            setPermissionRouter(data[i])
          }
        }
      })
      let getRouters = new Promise((resolve, reject) => {
        util.ajax.post('/core/manager/routers').then((res) => {
          generateGridRouter(res.data.data)
          resolve(res.data.data)
        }).catch(error => {
          console.error(error)
          console.error('初始化自定义路由失败！！')
          // resolve()
          reject(error)
        })
      })
      return Promise.all([getMenuTree, getRouters]).then(value => {
        commit(STORE_PERMISSION_MUTATION_TYPES.ROUTERS_INITIALIZED, true)
      }).catch(reason => {
        // 即使加载失败也设置为true，避免前端无限查询
        commit(STORE_PERMISSION_MUTATION_TYPES.ROUTERS_INITIALIZED, true)
        console.error(reason)
        console.error('init routers failed')
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js